import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a8e1749755b8c00148c5cbb_1788358210657_fc9d2188/naijaexplorer/src/app/global-error.tsx");
